import React, { useContext, useEffect, useState } from "react";
 
import "./MediosPago.css";

const MediosPago = ({acreditadoInfo}) => {
  return (
    <div className="MediosPago__container">
      <div className="MediosPago_title">
        Medios de pago
      </div>
      <div className="MediosPago_Item">
        <h1>Cajero BBVA Bancomer o Banca Móvil BBVA<span>(Anteriormente Bancomer)</span></h1>
        <h2>Convenio: 0016388  REFERENCIA: {acreditadoInfo.Refebbva}</h2>
      </div>
      <div className="MediosPago_Item">
        <h1>BANAMEX</h1>
        <h2>Sucursal: 076 NUM. CTA.: 7515332 REFERENCIA: {acreditadoInfo.Refebnmx}</h2>
      </div>
      {/* <div className="MediosPago_Item">
        <h1>BANCO AZTECA</h1>
        <h2>Sucursal: 0172 NUM. CTA.: 0140794930 REFERENCIA: {acreditadoInfo.Refebbva}</h2>
      </div> */}
       <div className="MediosPago_Item">
        <h1>Contraseña de Acreditado para pago en línea Página Web</h1>
        <h2> {acreditadoInfo.PassWeb}</h2>
      </div>
    </div>
  );
};

export default MediosPago;
